import React, { useState, useEffect } from "react";
import { Form, Button, Input, message, Modal, Select } from "antd";
import { useTranslation } from "react-i18next";
import { DownOutlined } from "@ant-design/icons";
import { apiClient } from "../Api/AllApi";

import "../Styles/AddProducts.css";
const AddUnit = () => {
  const [form1] = Form.useForm();
  const { t } = useTranslation();
  const [nameKurdish, setNameKurdish] = useState("");
  const [nameArabic, setNameArabic] = useState("");
  const [units, setUnits] = useState([]);
  const [parentId, setParentId] = useState(null);
  //todo this is Modal  Name
  const [isModalOpenNew, setIsModalOpenNew] = useState(false);

  const handleCancelNew = () => {
    setIsModalOpenNew(false);
  };
  const showModalNew = () => {
    setIsModalOpenNew(true);
  };

  const handleOkNew = () => {
    setIsModalOpenNew(false);
  };  //! End modal
  //! End modal

  const PostApi = async () => {
    try {
      let formData = new FormData();

      formData.append(
        "name",
        JSON.stringify({
          en: nameKurdish,
          ar: nameArabic,
        })
      );

      if (parentId) {
        formData.append("parent_id", parentId);
      }

      // Create a custom config for FormData
      const config = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      };

      const response = await apiClient.post('/units', formData, config);

      message.success("Form submitted successfully");
      window.location.href = "/GetUnit";
    } catch (error) {
      console.error("Error:", error);
      message.error("Failed to submit form. Please try again later.");
    }
  };
  //todo ---------------------------------------------------------------------
  const onFinish = (values) => {
    // console.log("Success:", values);
    // message.success("Success Post ");
  };
  const onFinishFailed = (errorInfo) => {
    // console.log("Failed:", errorInfo);
    message.error("Error");
  };
  const handleResetCart = () => {
    form1.resetFields();
  };
  //todo  -----------------------------------------------

  const layout = {
    labelCol: {
      span: 4,
    },
    wrapperCol: {
      span: 16,
    },
  };
  // Fetch available units for parent selection
  useEffect(() => {
    apiClient.get("/units")
      .then((response) => setUnits(response.data))
      .catch((error) => {
        console.error("Error fetching units:", error);
        message.error(t("Failed to fetch units"));
      });
  }, [t]);

  return (
    <div style={{ textAlign: "center", marginTop: "50px", direction: "rtl" }}>
      <h1 style={{ fontSize: "24px", marginBottom: "20px" }}>
        {t("unit add")}
      </h1>      <Form
        form={form1}
        {...layout}
        style={{
          fontSize: "18px", // Global font size for the entire form
        }}
        labelCol={{ span: 6 }} // Adjusts label width
        wrapperCol={{ span: 16 }} // Adjusts input width
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}      >
        {/* //TODO: name products ============== */}
        <Form.Item name="name" label={t("name")}>
          <Button
            type="text"
            style={{
              border: "1px solid #ccc",
              borderRadius: "4px",
              width: "70%",
              fontSize: "16px",
              textAlign: "center",
              display: "inline-block",

              backgroundColor: "#f0f0f0", // Change background color
              color: "#333", // Change text color
              fontWeight: "bold", // Make text bold
              boxShadow: "2px 2px 4px rgba(0, 0, 0, 0.1)", // Add a box shadow
            }}
            onClick={showModalNew}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {t("enter unit")}
              <DownOutlined />
            </div>
          </Button>

          <Modal
            style={{
              direction: "rtl",
            }}
            title={t("enter unit")}
            open={isModalOpenNew}
            onOk={handleOkNew}
            onCancel={handleCancelNew}
          >
            <Form
              form={form1}
              // onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              initialValues={{ remember: true }}
            >
              <Form.Item
                name="kurdish"
                label={t("كوردى")}
                value={nameKurdish}
                onChange={(e) => setNameKurdish(e.target.value)}
              >
                <Input />
              </Form.Item>
              <Form.Item
                name="arabic"
                label={t("عربي")}
                value={nameArabic}
                onChange={(e) => setNameArabic(e.target.value)}
              >
                <Input />
              </Form.Item>
            </Form>          </Modal>
        </Form.Item>

        {/* Parent Unit Selector */}
        <Form.Item name="parent_id" label={t("یەکەی سەرەکی")}>
          <Select
            placeholder={t("Select parent unit")}
            style={{ width: "70%", fontSize: "16px", textAlign: "center" }}
            value={parentId}
            onChange={(value) => setParentId(value)}
            allowClear
          >
            {units && units.map((unit) => (
              <Select.Option key={unit.id} value={unit.id}>
                {unit.name && typeof unit.name === 'string' ? JSON.parse(unit.name).en : ''}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        {/* //! end image ================================= */}

        <Form.Item label=".">
          <Button
            type="primary"
            style={{
              backgroundColor: "green",
              borderColor: "green",
              fontSize: "16px",
            }}
            htmlType="submit"
            onClick={PostApi}
          >
            {t("submit")}
          </Button>
          <span style={{ margin: "0 8px" }}></span>
          <Button
            type="primary"
            style={{
              backgroundColor: "blue",
              borderColor: "blue",
              fontSize: "16px",
            }}
            onClick={handleResetCart}
          >
            {t("reset")}
          </Button>
          <span style={{ margin: "0 8px" }}></span>
          <Button
            type="primary"
            style={{
              backgroundColor: "red",
              borderColor: "red",
              fontSize: "16px",
            }}
            onClick={() => (window.location.href = "/GetUnit")}
          >
            {t("cancel")}
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default AddUnit;
